module.exports = __webpack_public_path__ + "media/images/players/DEFAULT-2ce757ed50f5a593d453d1596d52ce80.png";